import { useMemo } from "react";

import clsx from "clsx";

import styles from "./NavbarUserProfile.module.scss";
import Button from "../support/Button";
import BodyText from "../support/BodyText";
import Dropdown from "../support/dropdown/Dropdown";
import DropdownIcon from "../support/dropdown/DropdownIcon";
import { DropdownButtonProps } from "../support/dropdown/DropdownButton";
import AuthProfileTypeIcon from "./AuthProfileTypeIcon";

enum ProfileOptions {
  MyOrders = "MyOrders",
  MyAccount = "MyAccount",
  ChangeProfile = "ChangeProfile",
  SignOut = "SignOut",
  GuestOnBoarding = "GuestOnBoarding",
}

function ProfileDropdownButton({
  className,
  isOpen,
  onToggle,
}: DropdownButtonProps) {
  return (
    <Button
      size="large"
      variant="secondary"
      onClick={onToggle}
      className={className}
    >
      <AuthProfileTypeIcon isCompany className={styles.profileIcon} />
      <span
        className={clsx(styles.profileContent, {
          [styles.outletDetailsPage]: false,
        })}
      >
        <BodyText as="span" className={styles.profileName}>
          James Warner
        </BodyText>

        <BodyText as="span" className={styles.profileUserName}>
          Warner PLC Group
        </BodyText>
      </span>
      <DropdownIcon isOpen={isOpen} />
    </Button>
  );
}

export default function NavbarUserProfile() {
  const navBarProfileOptions = useMemo(() => {
    const options = [
      {
        label: "My Orders",
        value: ProfileOptions.MyOrders,
      },

      {
        label: "My Account",
        value: ProfileOptions.MyAccount,
      },
      {
        label: "Change Profile",
        value: ProfileOptions.ChangeProfile,
      },

      {
        label: "Sign Out",
        value: ProfileOptions.SignOut,
      },
    ];

    return options.filter(Boolean) as Array<{
      label: string;
      value: ProfileOptions;
    }>;
  }, []);

  return (
    <Dropdown
      CustomDropdownButton={ProfileDropdownButton}
      popupPlacement="top-end"
      popupClassName={clsx(styles.profileDropdownPopup, {
        [styles.guestCustomer]: false,
      })}
      options={navBarProfileOptions}
    />
  );
}
